import { Link } from "react-router-dom";
import { CONTACT } from "@/constants/config";
import { useLang } from "@/constants/i18n";

export const Footer = () => {
    const { t } = useLang();
    return (
        <footer data-testid="footer" className="bg-ink pb-24 pt-16 text-ivory/60 md:pb-16">
            <div className="mx-auto max-w-7xl px-5 md:px-10">
                <div className="flex flex-col gap-10 border-b border-ivory/10 pb-10 md:flex-row md:items-start md:justify-between">
                    <div>
                        <p className="font-serif text-2xl text-ivory">FP Legacy Insurance</p>
                        <p className="mt-1 text-xs uppercase tracking-[0.3em] text-gold">
                            {t.footer.tagline}
                        </p>
                        <div className="mt-4 flex flex-col gap-1">
                            <a
                                href={CONTACT.phoneHref}
                                data-testid="footer-phone-link"
                                className="inline-block text-sm text-ivory/70 transition-colors duration-300 hover:text-gold"
                            >
                                {CONTACT.phoneDisplay}
                            </a>
                            <a
                                href={CONTACT.emailHref}
                                data-testid="footer-email-link"
                                className="inline-block text-sm text-ivory/70 transition-colors duration-300 hover:text-gold"
                            >
                                {CONTACT.email}
                            </a>
                            <Link
                                to="/resena"
                                data-testid="footer-review-link"
                                className="mt-2 inline-block text-xs uppercase tracking-[0.25em] text-gold/80 underline-offset-4 transition-colors duration-300 hover:text-gold hover:underline"
                            >
                                {t.footer.reviewLink}
                            </Link>
                        </div>
                    </div>
                    <div className="max-w-xl space-y-4 text-xs leading-relaxed">
                        <div>
                            <p className="mb-1 text-ivory/80">{t.footer.privacyTitle}</p>
                            <p>{t.footer.privacyText}</p>
                        </div>
                        <div>
                            <p className="mb-1 text-ivory/80">{t.footer.legalTitle}</p>
                            <p>{t.footer.legalText}</p>
                        </div>
                    </div>
                </div>
                <p className="mt-8 text-center text-xs text-ivory/35">
                    © {new Date().getFullYear()} FP Legacy Insurance. {t.footer.rights}
                </p>
            </div>
        </footer>
    );
};

export default Footer;
